import { ONE_MB_IN_BYTES } from '../AppConstants';

export function GetDelayTimeInMilliSecondForOneDriveUploadTask(fileSize: number): number {
  if (fileSize < ONE_MB_IN_BYTES * 25) {
    return 1000; // 1sec
  }
  return 5000; // 5 sec
}

export function GetDelayTimeInMilliSecondForBatchTranscriptionTask(fileSize: number): number {
  if (fileSize < ONE_MB_IN_BYTES * 25) {
    return 1000; // 1 sec
  }
  return 4000; // 4 sec
}
